var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"digivideo",staticClass:"azuremediaplayer amp-default-skin amp-big-play-centered",attrs:{"id":"azuremediaplayer","tabindex":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }